import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

export const useCopyLink = () => {
  const { t } = useTranslation();
  const location = useLocation();

  const handleCopyLink = async (
    isQuickView: boolean = false,
    entityId: string | null = null,
    customPathName?: string
  ) => {
    let pathname = customPathName ? customPathName : location.pathname;

    if (isQuickView && entityId) {
      pathname = `${pathname}/${entityId}`;
    }

    let fullUrl = `${window.location.origin}${pathname}${location.search}${location.hash}`;

    try {
      await navigator.clipboard.writeText(fullUrl);
      toast.success(t("copyLink.success"), {
        duration: 5000,
        icon: null
      });
    } catch (error) {
      toast.error(t("copyLink.error"), {
        icon: null
      });
    }
  };

  return handleCopyLink;
};
